/*
* Ref: https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
* 
* Use: const pageIsVisible = usePageVisibility(); 
*
* Return type: boolean
*/

import React, { useState, useEffect } from 'react';

let hidden, changeVisibility;

if (typeof document.hidden !== 'undefined') {
    hidden = 'hidden';
    changeVisibility = 'visibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    changeVisibility = 'webkitvisibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    changeVisibility = 'msvisibilitychange';
}

export default function usePageVisibility() {
    const [visible, setVisible] = React.useState(!document[hidden]);

    React.useEffect(() => {
        function handleChange() {
            setVisible(!document[hidden]);
        }

        document.addEventListener(changeVisibility, handleChange);

        return () => {
            document.removeEventListener(changeVisibility, handleChange);
        }
    }, []);

    return visible;
}